var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInputCloseDark = function SvgInputCloseDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.96 2.04c-2.722-2.72-7.198-2.72-9.92 0-2.72 2.722-2.72 7.198 0 9.92 2.722 2.72 7.198 2.72 9.92 0 2.72-2.722 2.72-7.11 0-9.92Z",
    fill: "#333444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15 9.853 6.956 7.658 4.762 9.853a.424.424 0 0 1-.615 0 .424.424 0 0 1 0-.615l2.195-2.194L4.147 4.85a.424.424 0 0 1 0-.615.424.424 0 0 1 .615 0L6.956 6.43 9.15 4.235a.424.424 0 0 1 .615 0 .424.424 0 0 1 0 .615L7.57 7.044l2.194 2.194a.424.424 0 0 1 0 .615.424.424 0 0 1-.615 0Z",
    fill: "#C4C4C5"
  }))));
};
export default SvgInputCloseDark;